module.exports = __webpack_public_path__ + "static/media/difficulty_3.509dd93f.svg";